import { render, staticRenderFns } from "./MessageBill.vue?vue&type=template&id=770eb996"
import script from "./MessageBill.vue?vue&type=script&lang=js"
export * from "./MessageBill.vue?vue&type=script&lang=js"
import style0 from "./MessageBill.vue?vue&type=style&index=0&id=770eb996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports